import {
  LINKEDIN_REPORT_CONTENT_ROWS,
  LINKEDIN_REPORT_PERFORMANCE_ROWS,
} from 'app/modules/analytics/modules/reports/constants/reportMetricRowDefinitions';
import PlatformReportPreviewSections from './PlatformReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const LinkedInReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <PlatformReportPreviewSections
    {...props}
    config={{
      performanceRows: LINKEDIN_REPORT_PERFORMANCE_ROWS,
      contentRows: LINKEDIN_REPORT_CONTENT_ROWS,
    }}
  />
);

export default LinkedInReportPreviewSections;
